module.exports = __webpack_public_path__ + "img/a.df0ebd2a.jpg";